<template>
  <div>
    <container :navWidth="80*4+44" detailWidth="340">
      <template v-slot:nav="{height}">
        <dialog-page-nav
            :height="height"
            :cats.sync="cats"
            :selectChat.sync="chat"
        />
      </template>
      <template v-slot:content="{height}">
        <dialog-page-chat
            ref="dialogPageChat"
            :height="height"
            :cats="cats"
            :chat="chat"
            :messageTemplates="messageTemplates"
            @close="chat=null"
            @requestTemplateSelect="(item)=>$refs.dialogPageMessageTemplates.selectTemplateSelect(item)"
        />
      </template>
      <template v-slot:detail="{height}">
        <dialog-page-message-templates
            ref="dialogPageMessageTemplates"
            :height="height"
            :items.sync="messageTemplates"
            :chat="chat"
            @select="(v)=>$refs.dialogPageChat.messageTemplateSelect(v)"
        />
      </template>
    </container>
    <audio ref="ring">
      <source src="../../../assets/ring.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import Container from "../../../componentsV2/base/Container.vue";
import DialogPageNav from "./components/DialogPageNav.vue";
import DialogPageChat from "./components/DialogPageChat.vue";
import DialogPageMessageTemplates from "./components/DialogPageMessageTemplates.vue";

export default {
  components: {DialogPageMessageTemplates, DialogPageChat, DialogPageNav, Container},
  data: () => ({
    cats:[],
    chat:null,
    messageTemplates: [],
    subscribeListenerId: null,
  }),
  mounted() {
    this.initWs();
  },
  beforeDestroy() {
    this.destroyWs();
  },
  watch: {
    '$store.state.user'(user, oldUser) {
      if (user === null)
        this.destroyWs();
      else if (oldUser === null || user.id !== oldUser?.id)
        this.initWs();
    },
  },
  methods: {
    initWs() {
      if (this.$store.state.user === null)
        return;
      if (this.subscribeListenerId !== null)
        return;
      this.$ws.connectWithSubscribeListener(this.$store.state.user, (v) => this.subscribeListenerId = v, (m) => {
        if (m.type === 'dialogChat')
          this.onDialogChatWs(m.data);
      });
    },
    destroyWs() {
      this.$ws.removeSubscribeListener(this.subscribeListenerId);
      this.subscribeListenerId = null;
    },
    onDialogChatWs(data) {
      const userId = this.$store.state.user?.id;
      const inChat = data.dialogUsers?.some(v => v.user?.id === userId);
      if (!inChat && data.cat !== 'queue')
        return;
      const mes = data.dialogMesLast;
      if (mes?.type === 'message' && mes.dialogUser?.user?.id !== userId)
        this.playDialogRing();
    },
    playDialogRing() {
      this.$tools.debounce(() => {
        this.$refs.ring?.play();
      }, 100, 'dialogRing');
    },
  }
}
</script>